export default function () {
  let html
  return {
    oninit: async vnode => {
      const res = await m.request('/about')
      html = res.html
    },
    view: vnode => {
      return m('.about', m.trust(html))
    }
  }
}
